// widok pozycji w wersji default
// @ts-nocheck

import React from "react";
import classnames from "classnames";
import { Trash, JournalText, Dash, Plus } from "react-bootstrap-icons";
import { Trans } from "react-i18next";
import { Menu, MenuItem } from "@mui/material";

import { IColumn } from "components/controls/Table";
import { ICartPositionListItem, IPositionUnit } from "api/types";
import { Availability, Checkbox, Select, Link } from "components/controls";
import WiseSelect from "components/wise/WiseSelect";

import QuantityWrapper from "components/containers/CartPositions/components/QuantityWrapper";
import { hasSpecialPriceLabel } from "utils/productHelpers";

import styles from "theme/components/containers/CartPositions/CartPositions.module.scss";
import classNames from "classnames";
import counterStyles from 'theme/components/controls/Counter/Counter.module.scss';

import serviceIcon from "assets/images/service-circle.png";

export const getEditColumns = ({
  cartId,
  onChange,
  queryParams,
  checkedItemIds,
  setCheckedItemIds,
  updatingPositionIds,
  handleChangeUnit,
  setItemsToShoppingList,
  setItemsToRemove,
  menuAnchor,
  setMenuAnchor,
  cartPositions,
}: {
  cartId: number;
  onChange?: () => void;
  queryParams: object;
  checkedItemIds: number[];
  setCheckedItemIds: (items: number[]) => void;
  updatingPositionIds: number[];
  handleChangeUnit: (unitId: number, position: ICartPositionListItem) => void;
  setItemsToShoppingList: (items: ICartPositionListItem[]) => void;
  setItemsToRemove: (items: ICartPositionListItem[]) => void;
  menuAnchor: HTMLButtonElement | null;
  setMenuAnchor: (anchor: HTMLButtonElement | null) => void;
  cartPositions: ICartPositionListItem[];
}): IColumn<ICartPositionListItem>[] => {
  const cartServicesAsPositions = cartPositions
    .map((value) => {
      if (value.type === "service") {
        return value.id;
      }
    })
    .filter((item) => !!item);

  return [
    {
      title: (
        <>
          <span className={styles.lpHeader}>Lp.</span>
          <button
            disabled={checkedItemIds.length === 0}
            className={classnames(styles.dropdownButton, {
              [styles.open]: !!menuAnchor,
            })}
            onClick={(event) => setMenuAnchor(event.currentTarget)}
          >
            <Checkbox
              checked={
                checkedItemIds.length > 0 &&
                checkedItemIds.length === cartPositions.length
              }
              indeterminate={
                checkedItemIds.length > 0 &&
                checkedItemIds.length < cartPositions.length
              }
              onClick={(event) => {
                event.stopPropagation();
                setCheckedItemIds(
                  checkedItemIds.length < cartPositions.length
                    ? cartPositions.map((position) => position.id)
                    : []
                );
              }}
            />
          </button>

          <Menu
            className={styles.menu}
            anchorEl={menuAnchor}
            open={!!menuAnchor}
            onClose={() => setMenuAnchor(null)}
          >
            <MenuItem
              className={styles.menuItem}
              onClick={() => {
                setItemsToRemove(
                  cartPositions.filter((position) =>
                    checkedItemIds.includes(position.id)
                  )
                );
                setMenuAnchor(null);
              }}
            >
              <Trash /> <Trans>Usuń</Trans>
            </MenuItem>
            <MenuItem
              className={styles.menuItem}
              onClick={() => {
                setItemsToShoppingList(
                  cartPositions.filter((position) =>
                    checkedItemIds.includes(position.id)
                  )
                );
                setMenuAnchor(null);
              }}
            >
              <JournalText /> <Trans>Dodaj do listy</Trans>
            </MenuItem>
          </Menu>
        </>
      ),
      key: "checkbox",
      align: "left",
      renderCell: (item, index) => {
        const isChecked = checkedItemIds.includes(item.id);
        const isCartService = cartServicesAsPositions.includes(item.id);

        return (
          <div className={styles.checkboxWrapper}>
            {!isCartService && (
              <Checkbox
                checked={isChecked}
                onClick={() =>
                  setCheckedItemIds(
                    isChecked
                      ? checkedItemIds.filter((checkbox) => checkbox !== item.id)
                      : [...checkedItemIds, item.id]
                  )
                }
              />
            )}
            <div className={styles.lp}>{index + 1}</div>
          </div>
        );
      },
      width: 100,
    },
    {
      title: "",
      key: "product-image",
      renderCell: (item) => {
        const isCartService = cartServicesAsPositions.includes(item.id);
        return (
          <div className={styles.productThumb}>
            {isCartService ? (
              <img src={serviceIcon} alt={item.name} />
            ) : (
              <Link to={`/${item.url_link}`}>
                <img src={item.image[0]?.thumb} alt={item.name} />
              </Link>
            )}
          </div>
        );
      },
      width: 78,
    },
    {
      title: <Trans>Nazwa produktu</Trans>,
      dataIndex: "name",
      align: "left",
      renderCell: (item) => {
        const isCartService = cartServicesAsPositions.includes(item.id);
        return (
          <div className={styles.productInfo}>
            {isCartService ? (
              <span>{item.name}</span>
            ) : (
              <>
                <Link to={`/${item.url_link}`}>{item.name}</Link>
                <div className={styles.grey}>{item.index}</div>
                <Availability stock={item.stock} units={item.units} source={item} />
              </>
            )}
          </div>
        );
      },
    },
    {
      title: <Trans>Ilość</Trans>,
      dataIndex: "quantity",
      align: "center",
      width: 150,
      renderCell: (item) => {
        const options = item.units.map((unit) => ({
          value: unit.unit_id,
          label:
            unit.converter !== 1
              ? `${unit.name} (${unit.converter})`
              : unit.name,
          item: unit,
        }));
        const unit = item.units.find((unit) => item.unit_id === unit.unit_id);

        const isCartService = cartServicesAsPositions.includes(item.id);

        return (
          <div className={styles.quantityCellWrapper}>
            {isCartService ? (
              <div
                className={classNames(
                  counterStyles.componentWrapper,
                  null,
                  "StylePath-Components-Controls-Counter"
                )}
              >
                <input
                  className={counterStyles.input}
                  value={item.quantity}
                  disabled={true}
                />
              </div>
            ) : (
              <QuantityWrapper
                cartId={cartId}
                item={item}
                onChange={onChange}
                queryParams={queryParams}
              />
            )}

            {unit?.name.length && (
              <>
                {!isCartService && options.length > 1 ? (
                  <WiseSelect<IPositionUnit>
                    value={item.unit_id}
                    options={options}
                    variant="small"
                    styleGroup="portal"
                    onChange={(unit) =>
                      handleChangeUnit(unit?.unit_id || 0, item)
                    }
                    disabled={updatingPositionIds.some(
                      (updatingPosition) => item.unit_id === updatingPosition
                    )}
                  />
                ) : (
                  <div>
                    <strong>{unit?.name}</strong>
                  </div>
                )}
              </>
            )}
          </div>
        );
      },
    },
    {
      title: <Trans>Jednostka</Trans>,
      dataIndex: "unit_id",
      align: "center",
      renderCell: (item) => {
        if (cartServicesAsPositions.includes(item.id)) {
          return null;
        }

        const unitData = item.units.find(
          (unit) => unit.unit_id === item.unit_id
        );

        return (
          <span className={styles.productUnit}>
            <strong>{item.quantity}</strong>
            {unitData?.name && (
              <>
                x <strong>{unitData?.name}</strong>
              </>
            )}
            {!!unitData?.converter_message && (
              <span className={styles.descriptionLine}>
                ({unitData.converter_message})
              </span>
            )}
          </span>
        );
      },
    },
    {
      title: <Trans>Cena netto</Trans>,
      dataIndex: "price_net",
      sortBy: "price_net",
      align: "right",
      renderCell: (item) => {
        const unitData = item.units.find(
          (unit) => unit.unit_id === item.unit_id
        );
        // Skróć nazwę jednostki do "Szt." jeśli to "Sztuka"
        const unitNameShort =
          unitData?.name === "Sztuka" ? "szt." : unitData?.name;
        const isCartService = cartServicesAsPositions.includes(item.id);

        return (
          <div className={styles.productPrice}>
            <span
              className={classnames({
                [styles.priceNetBlue]: hasSpecialPriceLabel(item),
              })}
            >
              {item.price_net_formatted} {item.currency}
            </span>
            {!isCartService && (
              <div className={styles.small}>
                <span
                  className={classnames({
                    [styles.priceNetBlue]: hasSpecialPriceLabel(item),
                  })}
                >
                  {item.unit_price_net_formatted} {item.currency}
                </span>{" "}
                ({unitNameShort})
              </div>
            )}
          </div>
        );
      },
    },
    {
      title: <Trans>Cena brutto</Trans>,
      dataIndex: "price_gross",
      sortBy: "price_gross",
      align: "right",
      renderCell: (item) => {
        const unitData = item.units.find(
          (unit) => unit.unit_id === item.unit_id
        );
        // Skróć nazwę jednostki do "Szt." jeśli to "Sztuka"
        const unitNameShort =
          unitData?.name === "Sztuka" ? "szt." : unitData?.name;
        const isCartService = cartServicesAsPositions.includes(item.id);

        return (
          <div className={styles.productPrice}>
            <span
              className={classnames({
                [styles.priceNetBlue]: hasSpecialPriceLabel(item),
              })}
            >
              {item.price_gross_formatted} {item.currency}
            </span>
            {!isCartService && (
              <div className={styles.small}>
                <span
                  className={classnames({
                    [styles.priceNetBlue]: hasSpecialPriceLabel(item),
                  })}
                >
                  {item.unit_price_gross_formatted} {item.currency}
                </span>{" "}
                ({unitNameShort})
              </div>
            )}
          </div>
        );
      },
    },
    {
      title: <Trans>Wartość</Trans>,
      dataIndex: "total_price_net",
      sortBy: "total_price_net",
      align: "right",
      renderCell: (item) => (
        <div className={styles.productTotalPrice}>
          <span
            className={classnames({
              [styles.priceNetBlue]: hasSpecialPriceLabel(item),
            })}
          >
            {item.total_price_net_formatted} {item.currency}{" "}
            <span className={styles.suffix}>
              <Trans>netto</Trans>
            </span>
          </span>
          <div className={styles.small}>
            <span
              className={classnames({
                [styles.priceNetBlue]: hasSpecialPriceLabel(item),
              })}
            >
              {item.total_price_gross_formatted} {item.currency}{" "}
              <span className={styles.suffix}>
                <Trans>brutto</Trans>
              </span>
            </span>
          </div>
        </div>
      ),
    },
    {
      title: <Trans>Opcje</Trans>,
      key: "actions",
      align: "center",
      renderCell: (item) => {
        const isCartService = cartServicesAsPositions.includes(item.id);
        if (isCartService) {
          return null;
        }
        return (
          <div className={styles.actionsWrapper}>
            <JournalText onClick={() => setItemsToShoppingList([item])} />
            <Trash onClick={() => setItemsToRemove([item])} />
          </div>
        );
      },
    },
  ];
};
